function beforeCutOffTime(sameDay) {
  const now = new Date();

  const brisbaneOffset = 10 * 60; // UTC+10
  const localOffset = now.getTimezoneOffset();
  const offsetDiff = brisbaneOffset + localOffset;

  const brisbaneTime = new Date(now.getTime() + offsetDiff * 60 * 1000);

  const cutOff = new Date(brisbaneTime);
  if (sameDay) {
    cutOff.setHours(9, 59, 0, 0);
  } else {
    cutOff.setHours(15, 30, 0, 0);
  }

  return brisbaneTime.getTime() < cutOff.getTime();
}

function calculateDeliveryDate(transitDays) {
  let sameDay = transitDays === 0;

  if (!beforeCutOffTime(sameDay)) {
    transitDays += 1;
  }

  let deliveryDate = new Date();
  while (transitDays > 0) {
    deliveryDate.setDate(deliveryDate.getDate() + 1);
    const day = deliveryDate.getDay();
    if (day !== 0 && day !== 6) {
      transitDays--;
    }
  }

  const day = deliveryDate.getDate();
  const month = deliveryDate.toLocaleString("en-AU", { month: "long" });

  function getOrdinalSuffix(n) {
    if (n >= 11 && n <= 13) return "th";
    switch (n % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  }

  return `${day}${getOrdinalSuffix(day)} ${month}`;
}

document.addEventListener("DOMContentLoaded", () => {
  const elements = document.querySelectorAll(".estimated-delivery");

  elements.forEach((el) => {
    const days = parseInt(el.dataset.days, 10) || 0;
    const estimatedDate = calculateDeliveryDate(days);
    el.textContent = estimatedDate;
  });
});
